import { manageTelemetryConsent } from '../scripts/observability/telemetry-consent'
import { resolveConfig } from '../scripts/observability/betterstack-config'

type ConsentWindow = Window & {
	__pvolveConsent?: { categories?: { performance?: boolean } }
	pvolveConsent?: { has: (category: string) => boolean }
	pvolveTelemetry?: ReturnType<typeof manageTelemetryConsent>
}
const host = window as unknown as ConsentWindow
const element = document.getElementById('pvolve-betterstack-config')
if (element && !host.pvolveTelemetry) {
	try {
		const config = resolveConfig(JSON.parse(element.textContent || '{}'), window.__themeVersion)
		if (config) {
			const allowed = () => host.__pvolveConsent?.categories?.performance === true && host.pvolveConsent?.has('performance') === true
			host.pvolveTelemetry = manageTelemetryConsent({
				allowed,
				subscribe(refresh) {
					const listener = (event: Event) => { if ((event as CustomEvent).detail?.key === 'performance') refresh() }
					document.addEventListener('pvolve:consent-category', listener)
					return () => document.removeEventListener('pvolve:consent-category', listener)
				},
				load: async () => {
					const { createRuntime } = await import('../scripts/observability/betterstack-runtime')
					return createRuntime(config, allowed)
				},
			})
		}
	} catch { /* Malformed diagnostics settings must never break the storefront. */ }
}
